module.exports = __webpack_public_path__ + "static/media/goals.412a8176.svg";